export const observeDOM = (() => {
  return function (
    w: Window & { MutationObserver?: any; WebKitMutationObserver?: any },
    obj: any,
    options: any,
    callback: (m: any) => void
  ) {
    const MutationObserver = w.MutationObserver || w.WebKitMutationObserver;
    if (!obj || obj.nodeType !== 1) {
      return;
    }

    if (MutationObserver) {
      var mutationObserver = new MutationObserver(callback);
      mutationObserver.observe(obj, options);
      return mutationObserver;
    } else {
      obj.addEventListener("DOMNodeInserted", callback, false);
      obj.addEventListener("DOMNodeRemoved", callback, false);
    }
  };
})();
